import { albums } from '@/configs/translates.config'

export default {
	'add-new-album': `add new ${albums.en.singular}`,
	album: albums.en.singular,
	'the-album': `the ${albums.en.singular}?`
}